var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "title_h1" }, [_vm._v("発注詳細")]),
      _c(
        "vab-query-form",
        {
          ref: "queryForm",
          attrs: {
            model: _vm.queryForm,
            rules: _vm.rules,
            size: "mini",
            "label-width": "98px",
          },
          on: { search: _vm.fetchData },
        },
        [
          _c(
            "vab-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "vab-col",
                { attrs: { lg: 8, xl: 8, md: 12 } },
                [
                  _c("vab-date-picker", {
                    staticClass: "width_140",
                    attrs: {
                      type: "month",
                      placeholder: "開始月",
                      label: "作業年月",
                      "value-format": "yyyyMM",
                      format: "yyyy/MM",
                      prop: "workYm",
                      validate: "required",
                      clearable: false,
                    },
                  }),
                ],
                1
              ),
              _c(
                "vab-col",
                { attrs: { lg: 8, xl: 8, md: 12 } },
                [
                  _c(
                    "el-row",
                    { attrs: { type: "flex" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("vab-input", {
                            attrs: { label: "建物", prop: "blgsnmkj" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "vab-col",
                { attrs: { lg: 8, xl: 8, md: 12 } },
                [
                  _c("MitmdtlpNew", {
                    ref: "itemDetailCdRef",
                    attrs: {
                      prop: "itemDetailCd",
                      componentcd: _vm.queryForm.itemDetailCd,
                      "multi-select": false,
                      span1: 6,
                      span2: 18,
                      "clear-validate": true,
                    },
                    on: {
                      "update:componentcd": function ($event) {
                        return _vm.$set(_vm.queryForm, "itemDetailCd", $event)
                      },
                      clearOtherData: _vm.clearOtherData,
                    },
                  }),
                ],
                1
              ),
              _c(
                "vab-col",
                { attrs: { lg: 8, xl: 8, md: 12 } },
                [
                  _c("vab-select", {
                    ref: "workSpecRef",
                    attrs: {
                      label: "点検仕様",
                      prop: "workSpecCdList",
                      "data-items": _vm.workSpecCdList,
                      "label-id": "itmgkmnm",
                      "value-id": "itmgkmcd",
                      "collapse-tags": "",
                      disabled: _vm.workSpecCdDisabled,
                      placeholder: "",
                      multiple: "",
                      clearable: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "vab-collapse",
                { attrs: { title: "詳細検索を表示" } },
                [
                  _c(
                    "vab-col",
                    { attrs: { lg: 8, xl: 8, md: 12 } },
                    [
                      _c("vab-select", {
                        ref: "groupRef",
                        attrs: {
                          label: "グループ",
                          prop: "groupList",
                          filter: "groupValue",
                          placeholder: "選択されていません",
                          "collapse-tags": "",
                          multiple: "",
                          clearable: "",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "vab-col",
                    { attrs: { lg: 8, xl: 8, md: 12 } },
                    [
                      _c("vab-select", {
                        attrs: {
                          label: "日程調整不要",
                          prop: "adjustUnnecessaryFlg",
                          "data-items": _vm.adjustUnnecessaryFlg,
                          "label-id": "text",
                          "value-id": "value",
                          clearable: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "vab-form",
        { ref: "form", attrs: { model: _vm.formObj, rules: _vm.rulesObj } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c("vab-table", {
                    ref: "table",
                    attrs: {
                      "api-url":
                        "/api/purchaseOrderDetailRc/queryOrderDetailList",
                      columns: _vm.columns,
                      "right-buttons": _vm.rightButtons,
                      "query-params": Object.assign({}, _vm.queryForm, {
                        sidx: "workNo,purchaseOrderDetailRcId",
                        sort: "desc,desc",
                      }),
                      "primary-key": "purchaseOrderDetailRcId",
                      span: 12,
                      "enable-init": _vm.reloadPage,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "blgsnmkj",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              { staticClass: "blgsnmkj_class" },
                              [
                                _c("svg-icon", {
                                  staticClass: "svg_icon",
                                  attrs: { "icon-class": "select_work" },
                                }),
                                _c(
                                  "el-link",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openBlgsnmkj(row)
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(row.blgsnmkj) + " ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "dateLimitContent",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("div", { staticClass: "flex_colum" }, [
                              _c("div", { staticClass: "pre_wrap" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getFieldValue(
                                        "dateLimitContentCanText",
                                        row.weekdayConditionSpecify
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getFieldValue(
                                        "dateLimitContentCannotText",
                                        row.weekdayConditionSpecify
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex_space mg12" },
        [_c("vab-button", { attrs: { "btn-list": _vm.makeList } })],
        1
      ),
      _c("Buildings", { ref: "building" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }